<agpr-take-over-panel
    [id]="id"
    class="agpr-clickOutsideExcluded"
    header="Social.filter.heading"
    [showFooter]="true"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
    [width]="80"
>
    <div class="agpr-filterWidget-container">
        <div class="agpr-filterWidget-lhp">
            <agpr-scroll-panel class="agpr-filterWidget-lhp-scrollPanel">
                <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                <ul
                    [id]="id + '_filterTypes'"
                    class="agpr-filterWidget-lhpList"
                    agprListKeyboardNavigation
                >
                    <li
                        *ngIf="savedFiltersType"
                        class="agpr-filterWidget-savedFilters"
                        [ngClass]="{
                            'filterType--selected': savedFiltersType === activeFilter
                        }"
                        [id]="id + '.savedFilters'"
                        (keydown)="selectFilterType(savedFiltersType, $event)"
                        (click)="selectFilterType(savedFiltersType, $event)"
                    >
                        {{ 'Common.filter.savedFilters' | localize }}
                        <agpr-button
                            class="agpr-filterWidget-savedFilters-manageIcon"
                            [icon]="'fa-regular fa-duotone fa-gear'"
                            [tooltip]="'Common.filter.manageSavedFilters'"
                            (keydown)="openManageSavedFilterDialog()"
                            (click)="openManageSavedFilterDialog()"
                        ></agpr-button>
                    </li>
                    <ng-container *ngFor="let section of filterSections; index as secIndex">
                        <li
                            class="filterType filterTypeGroup agpr-unfocusableListItem"
                        >
                            <h3> {{ "Social.filter.section." + section | localize }} </h3>
                        </li>
                        <li
                            *ngFor="let filter of filters[section]; index as i"
                            class="filterType"
                            [ngClass]="{
                                'filterType--selected': filter === activeFilter
                            }"
                            [id]="id + '_' + secIndex + '_filterType_' + i"
                            (keydown)="selectFilterType(filter, $event)"
                            (click)="selectFilterType(filter)"
                        >
                            @if (filter.id === 'keywords' && keywordFilter?.errors?.length){
                                <span
                                    role="img"
                                    class="filterType-errorIcon fa-regular fa-duotone fa-circle-exclamation"
                                ></span>
                            }
                            {{ filter?.label | localize }}
                        </li>
                    </ng-container>
                    <li
                        *ngFor="let filter of filtersWithoutSection; index as i"
                        class="filterType"
                        [ngClass]="{
                            'filterType--selected': filter === activeFilter
                        }"
                        [id]="id + '.filterType_' + i"
                        (keydown)="selectFilterType(filter, $event)"
                        (click)="selectFilterType(filter)"
                    >
                        @if (filter.id === 'keywords' && keywordFilter?.errors?.length){
                            <span
                                role="img"
                                class="filterType-errorIcon fa-regular fa-duotone fa-circle-exclamation"
                            ></span>
                        }
                        {{ filter?.label | localize }}
                    </li>
                </ul>
                <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
            </agpr-scroll-panel>
        </div>
        <div
            class="agpr-filterWidget-filterContent"
            [agprLoading]="activeFilter?.loading"
        >
            <agpr-filter-wrapper
                [filter]="activeFilter"
                [style]="style"
                [id]="id"
            ></agpr-filter-wrapper>
        </div>
        <div class="agpr-filterWidget-chipContainer">
            <agpr-message
                *ngIf="hasConflictingSavedFilters"
                [severity]="messageSeverityEnum.error"
                class="agpr-filterWidget-chipContainer-conflictSavedFilterError"
            >
                {{ 'Common.filter.savedFilters.conflictFilter.message' | localize }}
            </agpr-message>
            <agpr-scroll-panel>
                <div class="activeFilter-container">
                    <ng-container *ngFor="let filter of flatFilters">
                        <ng-container
                            #filterChipContainer
                            *ngIf="
                                filter.currentChips &&
                                filter.currentChips.length > 0
                                && filter.id !== 'savedFilters'
                            "
                        >
                            <div class="activeFilter-label">
                                {{ filter.label | localize }}
                            </div>
                            <label
                                *ngIf="filter.currentIncludeExclude && filter.showIncludeExclude"
                                class="activeFilter-subLabel"
                            >
                                {{ (filter.currentIncludeExclude === includeExclude.include ?
                                    'Common.filter.included' :
                                    'Common.filter.excluded') | localize }}
                            </label>
                            <ul
                                [id]="id + '_activeFilters'"
                                class="activeFilter-contents"
                                agprListKeyboardNavigation
                                listOrientation="horizontal"
                                [focusOnChild]="true"
                                [list]="filter.currentChips"
                                role="group"
                                [attr.aria-label]="filter.label | localize"
                            >
                                <ng-container *ngFor="let chip of filter.currentChips; let i = index">
                                    <div
                                        *ngIf="chip.labelArgs?.['firstInGroup'] && !chip.labelArgs?.['firstInFilter']"
                                        class="activeFilter-groupLabel"
                                    >
                                        {{ 'and' | localize }}
                                    </div>
                                    <li
                                        class="agpr-chip"
                                        [id]="id + '.chip_' + i"
                                    >
                                        <span
                                            class="agpr-chip-label"
                                            [pTooltip]="chip.tooltip ? (chip.tooltip | localize) : (chip.label | localize: chip.labelArgs)"
                                            tooltipPosition="top"
                                        >
                                            {{
                                                (chip.label | localize: chip.labelArgs) + (chip.suffix | localize)
                                            }}
                                        </span>
                                        <agpr-button
                                            [id]="id + '.chip_' + i + '.delete'"
                                            class="agpr-chip-button"
                                            [style]="buttonTypes.icon"
                                            icon="agpr-i-close"
                                            tooltip="Common.forms.chips.delete"
                                            tooltipPosition="top"
                                            [ariaLabel]="(chip.label | localize: chip.labelArgs) + ' ' + ('Common.forms.chips.delete' | localize)"
                                            (click)="removeChip(filter, chip)"
                                        ></agpr-button>
                                    </li>
                                </ng-container>
                            </ul>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="savedFiltersType?.filterCards.length > 0">
                        <div class="savedFilters-container" *ngFor="let card of savedFiltersType.filterCards; index as i">
                            <label class="savedFilters-label">
                                {{ card.label }}
                            </label>
                            <!-- Compatible Saved Filter Chips -->
                            <ng-container *ngFor="let filter of card.filters">
                                <ng-container
                                    *ngTemplateOutlet="filterCard, context: {filter: filter, card: card}"
                                ></ng-container>
                            </ng-container>
                              <!-- Incompatible Saved Filter Chips -->
                            <ng-container *ngFor="let filter of card.inCompatibleFilters; let first = first">
                                <div *ngIf="first && card.filters?.length > 0" class="savedFilters-separator"></div>
                                <label
                                    *ngIf="first"
                                    class="savedFilters-incompatibleMessage"
                                >
                                   {{ 'Common.filter.savedFilters.incompatibleFilterMessage' | localize }}
                                </label>

                                <ng-container
                                    *ngTemplateOutlet="filterCard, context: {filter: filter, card: card}"
                                ></ng-container>
                            </ng-container>

                            <ul class="savedFilters-contextMenu">
                                <li>
                                    <agpr-button
                                        [id]="id + i + '_ungroup'"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-link-slash'"
                                        tooltip="Common.filter.savedFilters.ungroupSavedFilters"
                                        tooltipPosition="top"
                                        (click)="ungroupSavedFilter(card)"
                                    ></agpr-button>
                                </li>
                                <li>
                                    <agpr-button
                                        [id]="id + i + '_edit'"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-pen'"
                                        tooltip="Common.filter.savedFilters.editSavedFilters"
                                        tooltipPosition="top"
                                        (click)="openSavedFilterEditDialog(card)"
                                    ></agpr-button>
                                </li>
                                <li>
                                    <agpr-button
                                        [id]="id + i + '_delete'"
                                        [style]="buttonTypes.contextMenu"
                                        [icon]="'fa-regular fa-duotone fa-square-xmark'"
                                        tooltip="Common.filter.savedFilters.removeSavedFilters"
                                        tooltipPosition="top"
                                        (click)="removeFilterCard(card)"
                                    ></agpr-button>
                                </li>
                            </ul>
                        </div>
                    </ng-container>

                    <ng-template #filterCard let-filter="filter" let-card="card">
                        <ng-container *ngIf="filter.chips && filter.chips.length > 0">
                            <label class="savedFilters-filterName">
                                {{ filter.filterName | localize }}
                            </label>
                            <label
                                *ngIf="filter.includeExclude"
                                class="activeFilter-subLabel"
                            >
                                {{ (filter.includeExclude === includeExclude.include ?
                                    'Common.filter.included' :
                                    'Common.filter.excluded') | localize }}
                            </label>
                            <ul
                                [id]="id + filter.filterName +'_filters'"
                                class="activeFilter-contents"
                                agprListKeyboardNavigation
                                listOrientation="horizontal"
                                [focusOnChild]="true"
                                [list]="card.filters"
                                role="group"
                                [attr.aria-label]="filter.filterName | localize"
                            >
                                <ng-container *ngFor="let chip of filter.chips; let i = index">
                                    <div
                                        *ngIf="chip.labelArgs?.['firstInGroup'] && !chip.labelArgs?.['firstInFilter']"
                                        class="activeFilter-groupLabel"
                                    >
                                        {{ 'and' | localize }}
                                    </div>
                                    <li
                                        class="agpr-chip savedFilters-chip"
                                        [id]="id + '.chip_' + i"
                                    >
                                        <span
                                            class="agpr-chip-label"
                                            [pTooltip]="chip.tooltip ? (chip.tooltip | localize) : (chip.label | localize: chip.labelArgs)"
                                            tooltipPosition="top"
                                        >
                                            {{
                                                (chip.label | localize: chip.labelArgs) + (chip.suffix | localize)
                                            }}
                                        </span>
                                    </li>
                                </ng-container>
                            </ul>
                            <agpr-form-message #conflictingSavedFilterMessage *ngIf="filter.errorMessage"> {{ filter.errorMessage }} </agpr-form-message>
                        </ng-container>
                    </ng-template>
                </div>
            </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #takeOverFooterLeft class="agpr-filterWidget-footer">
        <agpr-button
            [id]="id + '.cancelButton'"
            label="Core.button.cancel"
            (click)="cancel()"
            [style]="buttonTypes.secondary"
        ></agpr-button>
        <agpr-button
            [id]="id + '.clearButton'"
            label="Core.button.clear"
            (click)="clear()"
            [style]="buttonTypes.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        @let keywordFilterErrorMsg = keywordFilter?.errors?.length
            ? ('Common.filter.error.tooltip' | localize: {error: keywordFilter?.getErrorMessages(true)})
            : '';
        <agpr-button
            *ngIf="savedFiltersType"
            [id]="id + '.saveButton'"
            [style]="buttonTypes.primaryB"
            label="save"
            [tooltip]="keywordFilterErrorMsg"
            tooltipPosition="top"
            [disabled]="savedFiltersType?.filterCards.length > 0 || !hasFilters || !!keywordFilterErrorMsg"
            (click)="openSaveFilterDialog()"
        ></agpr-button>
        <agpr-button
            [id]="id + '.applyButton'"
            [style]="buttonTypes.primary"
            label="Core.button.apply"
            [tooltip]="keywordFilterErrorMsg"
            tooltipPosition="top"
            [disabled]="!!keywordFilterErrorMsg"
            (click)="apply()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
